import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const ExtraWorkOrdersBreadcrumb = () => {
  const { t } = useTranslation('extraWorkOrdersModule');

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    return [
      {
        label: t('title', 'Trabajos Extra'),
        title: t('title', 'Trabajos Extra'),
      },
    ];
  }, [t]);

  usePageNavigation({ breadcrumbs });

  return null;
};
